import { useRef, useState } from "react";
import FieldCard from "./FieldCard";

// Center column: drag-and-drop canvas. DnD logic same (native HTML5).
export default function Canvas({
  fields,
  selectedId,
  onSelect,
  onRemove,
  onAdd,
  onMove,
}) {
  const dragId = useRef(null);
  const [dropHint, setDropHint] = useState(null); // { index, pos }

  const dnd = {
    onDragStart: (id) => (e) => {
      dragId.current = id;
      e.dataTransfer.effectAllowed = "move";
    },
    onDragOver: (index) => (e) => {
      if (dragId.current == null) return;
      e.preventDefault();
      const r = e.currentTarget.getBoundingClientRect();
      const after = e.clientY > r.top + r.height / 2;
      setDropHint({ index, pos: after ? "after" : "before" });
    },
    onDrop: (index) => (e) => {
      if (dragId.current == null) return;
      e.preventDefault();
      const r = e.currentTarget.getBoundingClientRect();
      const after = e.clientY > r.top + r.height / 2;
      onMove(dragId.current, after ? index + 1 : index);
      dragId.current = null;
      setDropHint(null);
    },
    onDragEnd: () => {
      dragId.current = null;
      setDropHint(null);
    },
  };

  const onCanvasDrop = (e) => {
    const newType = e.dataTransfer.getData("newtype");
    if (newType) {
      e.preventDefault();
      onAdd(newType);
    }
  };

  return (
    <div className="card shadow-sm">
      <div className="card-header py-2 small fw-semibold text-secondary text-uppercase">
        Form layout · drag to reorder
      </div>
      <div
        className="card-body p-3"
        style={{ minHeight: 300 }}
        onDragOver={(e) => {
          if (e.dataTransfer.types.includes("newtype")) e.preventDefault();
        }}
        onDrop={onCanvasDrop}
      >
        {fields?.length === 0 && (
          <div className="border fb-dashed rounded text-center text-secondary small py-5">
            Click a field type, or drag it here to begin.
          </div>
        )}
        {fields?.map((f, i) => (
          <FieldCard
            key={f.id}
            field={f}
            index={i}
            selected={selectedId === f.id}
            dropHint={dropHint && dropHint.index === i ? dropHint.pos : null}
            onSelect={onSelect}
            onRemove={onRemove}
            dnd={dnd}
          />
        ))}
      </div>
    </div>
  );
}
